import { SidebarCardLocationWrapper } from './SidebarCardLocationWrapper';
import { useCardLocationContext } from 'crm-cards-sdk/internal/CardLocationContext';
import Raven from 'raven-js';

// Scopes and gates need to be passed in because we can't get them all from the context
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const MaybeSidebarCardLocationWrapper = ({
  children,
  gates,
  legacySidebarCardProps,
  scopes,
  supportLegacyCards
}) => {
  const {
    additionalLocationData,
    editableAreasAtom
  } = useCardLocationContext();
  const {
    objectId,
    objectTypeId
  } = additionalLocationData;
  if (supportLegacyCards) {
    // Probably don't actually want to break the whole location if a Sidebar is included
    // but no objectId
    if (!(objectId && objectTypeId)) {
      Raven.captureException(new Error('Attempted to render SidebarCardLocationWrapper without objectId or ObjectTypeId'), {
        extra: {
          objectId,
          objectTypeId
        }
      });
      return /*#__PURE__*/_jsx(_Fragment, {
        children: "SidebarCardLocationWrapper requires an objectId and objectTypeId"
      });
    }
    return /*#__PURE__*/_jsx(SidebarCardLocationWrapper, {
      editableAreasAtom: editableAreasAtom,
      gates: gates,
      legacySidebarCardProps: legacySidebarCardProps,
      objectId: `${objectId}`,
      objectTypeId: objectTypeId,
      scopes: scopes,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default MaybeSidebarCardLocationWrapper;